import React, { PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import { LoginForm } from 'login/containers';

/**
 * Modal wrapping login component.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const LoginModal = ({ showing, onClose, next, onSuccess }) => {
  return (
      <ModalDialog
        dialogClasses="login-modal"
        modalOpen={showing}
        closeAction={onClose}
        modalHeader="Login"
        onPrimary={onClose}
        primaryLabel="Cancel"
        primaryClasses="btn btn-text btn-block"
      >
        <LoginForm next={next} onSuccess={onSuccess} hideOptions={true}/>
      </ModalDialog>
  );
}

export default LoginModal;



// WEBPACK FOOTER //
// ./login/components/login_modal.jsx